import OutlineSix from '@assets/icons/outline-six.svg'
import { Icon } from './Icon'

export const OutlineSixIcon = Icon(OutlineSix)
